/* URLY Produktseite: Galerie, Menge, Abo, The-Lock-In-Popup */
(function(){
var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function init(root){
if (root.dataset.upInit) return; root.dataset.upInit = '1';
var track = root.querySelector('[data-track]');
var n = track ? track.children.length : 0;
var count = root.querySelector('[data-count]');
function idx(){ return Math.round(track.scrollLeft / track.clientWidth); }
function go(i){ i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
function mark(){
var i = idx();
if (count) count.textContent = (i + 1) + ' / ' + n;
root.querySelectorAll('[data-go]').forEach(function(b){ b.setAttribute('aria-current', String(+b.getAttribute('data-go') === i)); });
}
if (track && n > 1) {
var t; track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(mark, 60); });
root.querySelector('[data-prev]').addEventListener('click', function(){ go(idx() - 1); });
root.querySelector('[data-next]').addEventListener('click', function(){ go(idx() + 1); });
root.querySelectorAll('[data-go]').forEach(function(b){ b.addEventListener('click', function(){ go(+b.getAttribute('data-go')); }); });
track.addEventListener('keydown', function(e){ if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); } });
}
root.querySelectorAll('[data-plan]').forEach(function(r){
r.addEventListener('change', function(){
var h = root.querySelector('[data-plan-input]');
if (!h) return;
h.value = r.value; h.disabled = !r.value;
});
});
var qin = root.querySelector('input[name=quantity]');
function setQty(q){
if (!qin) return;
q = Math.max(1, Math.min(20, q || 1)); qin.value = q;
root.querySelectorAll('[data-qty-set]').forEach(function(t){ t.setAttribute('aria-pressed', String(Math.min(q, 3) === +t.getAttribute('data-qty-set'))); });
}
root.querySelectorAll('[data-qty]').forEach(function(b){
b.addEventListener('click', function(){ setQty((+qin.value || 1) + (+b.getAttribute('data-qty'))); });
});
root.querySelectorAll('[data-qty-set]').forEach(function(b){
b.addEventListener('click', function(){ setQty(+b.getAttribute('data-qty-set')); });
});
if (qin) qin.addEventListener('change', function(){ setQty(+qin.value); });

/* Popup: nach Einzelkauf die anderen zwei anbieten */
var pop = root.querySelector('[data-up-pop]');
var single = root.querySelector('form[id^="up-form-"]');
if (!pop || !single || typeof pop.showModal !== 'function' || !window.fetch) return;
single.addEventListener('submit', function(e){
if (qin && +qin.value > 1) return;
e.preventDefault();
fetch(ROOT + 'cart/add.js', { method: 'POST', body: new FormData(single), headers: { 'Accept': 'application/json' } })
.then(function(r){ if (!r.ok) throw r; pop.showModal(); })
.catch(function(){ single.submit(); });
});
pop.querySelector('[data-pop-close]').addEventListener('click', function(){ pop.close(); });
pop.addEventListener('close', function(){ if (!pop.dataset.added) location.reload(); });
var add = pop.querySelector('[data-pop-add]');
add.addEventListener('click', function(){
var items = add.getAttribute('data-ids').split(',').filter(Boolean).map(function(id){ return { id: +id, quantity: 1 }; });
add.disabled = true;
fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
.then(function(r){ if (!r.ok) throw r; pop.dataset.added = '1'; location.href = ROOT + 'cart'; })
.catch(function(){ add.disabled = false; location.href = ROOT + 'cart'; });
});
}
function all(){ document.querySelectorAll('.up[id^="up-"]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
document.addEventListener('shopify:section:load', all);
})();
